// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2QPWO","image":"Header_image__1itmo","name":"Header_name__1zReX","info":"Header_info__3yRv1","infoRow":"Header_infoRow__T_VYz"};